import React from 'react'
import { FleetDataType } from 'src/core/models'
import { getFirstSubstring } from 'src/core/helpers'
import styles from './FleetListMovileViewColumn.module.scss'
import { FormLabels, FleetListActionsColumn, CustomLink } from 'src/components'

const FleetListMovileViewColumn: React.FC<{ fleet: FleetDataType }> = ({ fleet }) => {
  const fileName = (fleet.file as string).split('/').pop()

  return (
    <div className={styles.content}>
      <FormLabels
        title={fleet.country}
        subtitle={fleet.period}
      />
      <div className={styles.actions}>
        <CustomLink
          link={fleet.file as string}
          label={`${getFirstSubstring(fileName, 20)}...`}
          showIcon={true}
        />
        <FleetListActionsColumn fleet={fleet} />
      </div>
    </div>
  )
}

export default FleetListMovileViewColumn
